import { Button, Card, Input, Media, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SupportDto } from "../../../../models/supportDto";

import hasRoles from "../../../../security/hasRoles";
import keycloak from "../../../../security/keycloak-config";
import styles from "./documentCard.module.scss";
import Switch from "react-switch";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { useState } from "react";
import Pdf from "../../../../assets/images/icons/pdf.png";
import ClickAwayListener from "react-click-away-listener";
import { translate } from "react-switch-lang";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";


const DocumentCard: React.FC<{
  t: (key: string) => {};
  data: SupportDto;
  handleClickOpenModalViewer: (data: SupportDto) => void;
  handleClickOpenModalEditSupport: (data: SupportDto) => void;
  handleDeleteSUpport: (supportId: number) => void;
  getDocumentIconFromExtension: (path: string) => string;
  handleDownloadDocument: (data: SupportDto) => void;
}> = ({ t, data, handleClickOpenModalViewer, handleClickOpenModalEditSupport, handleDeleteSUpport, getDocumentIconFromExtension, handleDownloadDocument }) => {
  const httpClient = useHttpClient(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [checked, setChecked] = useState(data?.download);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [langdropdown, setLangdropdown] = useState(false);

  const handleChangeToggleDownload = () => {
    data.download = !data.download;
    setChecked(!checked);
    httpClient.current?.put("/support", data).then();
  };
  const LanguageSelection = language => {
    setLangdropdown(!language);
  };

  const handleSetLanguage = key => {
    setLangdropdown(false);
  };
  
  const openModel = (url) => {
    setUrl(url)
    toggle()
  };

  const [modal, setModal] = useState(false);
  const [url, setUrl] = useState('');
  const toggle = () => setModal(!modal);

  const closeModel = () => {
    setModal(false);
  };

  const redirectToSupport = (url) => {
    window.open(url, '_blank');
    closeModel()
  };

  return (
    <>
    <Modal className={styles["modal-aide"]} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("model_biblio_title")}</ModalHeader>
        <ModalBody>
        <Input className="form-control" type="email" readOnly value={url}/>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={() =>redirectToSupport(url)}>
             {t("model_biblio_button")}
          </Button>
        </ModalFooter>
    </Modal>
    <Card className={styles["card-document"]}>
      <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
        <div className="product-img text-center">
          {data.urlImage ? (
            <Media className={styles["img-card"] + " img-fluid top-radius-blog"} src={data.urlImage + ""} alt="" />
          ) : (
            <Media className={styles["image-pdf"] + " img-fluid top-radius-blog"} src={Pdf} alt="" />
          )}
          <div className="product-hover">
            <ul>
              <li onClick={() => handleClickOpenModalViewer(data)} style={{ width: "auto" }}>
                <i className="icon-eye">{hasRoleAdmin && <span className="m-l-5">{data.numberView}</span>}</i>
              </li>
              {(data.download || hasRoleAdmin) && (
                <li style={{ width: "auto" }}>
                  <a onClick={() => handleDownloadDocument(data)} href={data.urlSupport + "/download"}>
                    <i className="icon-import m-r-5"> {hasRoleAdmin && data.numberDownload}</i>
                  </a>
                </li>
              )}
              <li onClick={() => openModel(data.urlSupport)} style={{ width: "auto" }}>
                <i className="fa fa-share-alt"></i>
              </li>
            </ul>
          </div>
        </div>
        <div className="blog-details-main">
          <h6 title={data.title} className={styles["title-card"] + " blog-bottom-details"}>
            {data.title}
          </h6>
          <hr />
          <ul className="blog-social">
            <li className="digits">
              <i className={styles["icon-timer"] + " icofont icofont-ui-timer"}></i> {data.dateSupport}
            </li>
            <li className={styles["digit"] + " digits"}>
              <i className={styles["icon-flad"] + " fa fa-flag-o"}></i>
              <span title={data.listCountry.map(element => selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais).toString()}>
                {data.listCountry.length === 1
                  ? selectedLanguage === "en" ? data?.listCountry[0]?.titleAnglais : data?.listCountry[0]?.titleFrancais
                  : t("label_multi_countries")}
              </span>
            </li>

            {hasRoleAdmin && (
              <>
                <li className="digits">
                  <Switch className={styles["switch-button-download"]} height={15} width={29} onChange={handleChangeToggleDownload} checked={data.download} />
                </li>

                <li className="digits">
                  <ClickAwayListener onClickAway={() => handleSetLanguage("en")}>
                    <div className={`${styles["translate_wrapper"]} ${langdropdown ? styles["active"] : ""}`}>
                      <div className={styles["current_lang"]}>
                        <div className={styles["lang"]} onClick={() => LanguageSelection(langdropdown)}>
                          <i className="fa fa-gear"></i>
                        </div>
                      </div>

                      <div className={`${styles["more_lang"]} ${langdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            event.stopPropagation();
                            handleSetLanguage("en");
                            handleClickOpenModalEditSupport(data);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " fa fa-edit " + styles["icon-update"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_update")}</span>
                        </div>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            handleSetLanguage("fr");
                            event.stopPropagation();
                            handleDeleteSUpport(data.supportId);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-trash " + styles["icon-delete"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_delete")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </Card>
    </>
    
  );
};

export default translate(DocumentCard);
